import { getStatic, set } from '../local-storage';
import { definitions, subscribe } from '../message-broker';
import { getStore } from '../store';
import featuresConfiguration from './configuration';

let features = {};

const STAGES = {
  alpha: 10,
  beta: 20,
  rc: 30,
  rollout: 40,
  stable: 40,
};

const setFeatures = (nextFeatures) => {
  features = { ...nextFeatures };
  set('featureService', 'features', features);
};

export const getFeatures = () => features;
export const getFeaturesConfiguration = () => featuresConfiguration;

export const toggleFeature = (featureName, value = undefined) => {
  setFeatures({
    ...features,
    [featureName]: value === undefined ? !features[featureName] : !!value,
  });
  // We only store the features that are _selected_ otherwise we remove them.
  const existingFeatures =
    getStatic('featureService', 'userSelectedFeatures') || {};

  set(
    'featureService',
    'userSelectedFeatures',
    {
      ...existingFeatures,
      [featureName]: features[featureName] ? features[featureName] : undefined,
    },
    true,
  );
};

export const updateFeaturesForMember = () => {
  const member = getStore().getState().backendService.currentMember;
  const {
    featureLevel = 'stable',
    featureRolloutOrder = 1,
    specificFeatures,
  } = member || {};
  const specificFeaturesRedressed = specificFeatures || [];
  const availableFeatures = featuresConfiguration;
  const selectedFeatures =
    getStatic('featureService', 'userSelectedFeatures') || {};
  const isPartOfRollout = (rolloutSize, rolloutOffset) =>
    featureRolloutOrder >= rolloutOffset &&
    featureRolloutOrder <= rolloutOffset + rolloutSize;

  setFeatures({
    ...Object.keys(availableFeatures)
      .filter(
        (featureName) =>
          STAGES[featureLevel] <=
            STAGES[availableFeatures[featureName].stage] ||
          specificFeaturesRedressed.indexOf(featureName) !== -1,
      )
      .reduce((collector, featureName) => {
        const {
          stage,
          rolloutSize = 10,
          rolloutOffset = 0,
        } = availableFeatures[featureName];
        let enabled;
        if (specificFeaturesRedressed.indexOf(featureName) !== -1) {
          enabled = true;
        } else if (stage === 'stable') {
          enabled = true;
        } else if (stage === 'rollout') {
          enabled = isPartOfRollout(rolloutSize, rolloutOffset);
        } else {
          // This gets overwritten by selectedFeatures below.
          enabled = false;
        }
        collector[featureName] = enabled;
        return collector;
      }, {}),
    // In the event that a user has previously been logged in and has selected features, or
    // they are currently logged in as well, then set these features as available. This means
    // that feature users can log in and set features up, then try them as unauthenticated users.
    ...selectedFeatures,
  });
};

export const initialize = () => {
  setFeatures(getStatic('featureService', 'features'));
  // running this on initialize so that stable features get added
  updateFeaturesForMember();

  subscribe(definitions.authentication.stateChange, () => {
    updateFeaturesForMember();
  });
};

export const hasFeatureEnabled = (featureName) =>
  features && features[featureName];
